import { styled } from "../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "fit-content",
});

export const StyledLegend = styled("li", {
  listStyleType: "none",

  gap: "8px",
  display: "flex",
  alignItems: "center",

  color: "$gray-90",

  lineHeight: "18px",
  fontSize: "$text-md",

  marginLeft: "-2px",
});

export const PlaceholderDashedLine = styled("span", {
  display: "inline-block",
  width: "44px",
  height: 0,
  borderTop: "2px dashed $gray-60",
});
